const projectData = {
    "projects": [
        {
            'id': "the-land-of-bullshit",
            "title": "The Land of Bulls*t",
            "video": "https://lyds.s3-ap-southeast-2.amazonaws.com/The+Land+of+Bullshit.mp4",
            "description": "",
            "start_time": 0
        },
        {
            "id": "twat",
            "title": "Twat.",
            "description": "<p>Never a button missing or a pen out of place, she prides her self on the articulation and control of life. She can’t comprehend why she’s surrounded by nitwits and newts, twats as she likes to call them. But things get out of hand when Elizabeth comes face to face with her Achilles heel.</p>",
            "video": "https://lyds.s3-ap-southeast-2.amazonaws.com/twat_02.mp4",
            "start_time": 1
        },
        {
            "id": "cider",
            "title": "cider folks",
            "video": "https://lyds.s3-ap-southeast-2.amazonaws.com/Cider+Chat+-+Peckhams+720HD+Small.mp4",
            "description": "Tina, Darrel & Prudence give their 10 cents on cider...",
            "start_time": 3.5
        },
        {
            "id": "fussy",
            "title": "Fussy",
            "description": "<p>Kathalene gets flustered as she tries to find love in a hopeless place. An unwelcome pigeon has been courting her... is Benji her last hope. Kathalene gets flustered as she tries to find love in a hopeless place. An unwelcome pigeon has been courting her... is Benji her last hope.</p>",
            "video": "https://lyds.s3-ap-southeast-2.amazonaws.com/Finding+Love.mp4",
            "start_time": 1.5
        },
        {
            "id": "sourdough-baby",
            "title": "Sourdough Baby",
            "description": "<p>Enthralled and empowered by the age old art of bread making, Beatrice has grown maternal for her sourdough starter. Her sourdough baby. A woman perhaps to attached, or rightly so?</p>",
            "video": "https://lyds.s3-ap-southeast-2.amazonaws.com/Sourdough+Baby+-+Final+File+Size+Small.mp4",
            "start_time": 2
        },
        {
            "id": "known unknown",
            "title": "Known Unknown",
            "description": "TBD",
            "video": "https://lyds.s3-ap-southeast-2.amazonaws.com/Known+Unkown.mp4",
            "start_time": 0
        }
    ]
}

export default projectData;